import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, isMobile } from '@pascal/pascal-core';
import { globalTranslationKeys, oddDataForHelpPopUp } from '../../../../enums';
import InfoImg1 from '../../../../assets/images/info-img1.png';
import InfoImg2 from '../../../../assets/images/info-img2.png';
import InfoImg3 from '../../../../assets/images/info-img3.png';
import InfoImg4 from '../../../../assets/images/info-img4.png';
import Logo from '../../../../assets/images/logo.png';
import AutoBetImage from '../../../../assets/images/autobet-image.png';
import AutoBetSwitcher from '../../../../assets/images/autobet-switcher.png';
import AutoBetPoint from '../../../../assets/images/autobet-point.png';
import AutoBetSwitcherActive from '../../../../assets/images/autobet-switcher-active.png';
import AutoBetImage2 from '../../../../assets/images/autobet-image-2.png';
import { decideCurrentBetType } from '../../../../helpers/supporters';

export const GameSpecificCheckHashPopupTopSection = ({ isFromBetHistory, currentData, t }) => {
  const { roundData, additionalParams } = currentData;
  const { GameResult, BetType, Markets, Manual, CashOut } = globalTranslationKeys;
  const { markets } = additionalParams || {};

  return (
    <div className='game-result-specific-popup'>
      <div className='g-res-spec-pop-holder'>
        <div className='g-res-spec-pop-title'>
          <p className='g-res-spec-pop-title-txt'>{t(GameResult)}</p>
        </div>
        <div className='g-res-spec-pop-inside'>
          <p className='g-res-spec-coef'>x{roundData?.odd}</p>
        </div>
      </div>
      {isFromBetHistory && (
        <>
          <p className='g-res-spec-pop-txt-type'>{t(BetType)}</p>
          <p className='g-res-spec-pop-txt-type type1'>{t(markets ? Markets : Manual)}</p>
          <p className='g-res-spec-pop-txt-type'>
            {markets ? (
              <span>{decideCurrentBetType(currentData)}</span>
            ) : (
              <>
                {t(CashOut)} <span>x{currentData.odd}</span>
              </>
            )}
          </p>
        </>
      )}
    </div>
  );
};

export const AutoBetPopupTabContent = ({ t }) => {
  return (
    <>
      <p>{t('GAME_RULES_P14')}</p>
      <p>{t('GAME_RULES_P15')}</p>
      <p>{t('GAME_RULES_P16')}</p>
      <div className='autocashout-image-wrapper'>
        <img src={AutoBetImage} className='autocahout-image' alt='' />
        <div className='autocahout-autobet-row'>
          <i>{t(globalTranslationKeys.AutoBet)}</i>
          <img src={AutoBetSwitcher} alt='' />
        </div>
        <div className='autocahout-autobet-row-2'>
          <i>{t(globalTranslationKeys.AutoBet)}</i>
          <div className='autocashout-autobet-row-inner'>
            <img className='autocashout-autbet-points' src={AutoBetPoint} alt='' />
            <img className='autocashout-autbet-points2' src={AutoBetSwitcherActive} alt='' />
          </div>
        </div>
      </div>
    </>
  );
};
export const AutoCashOutPopupTabContent = ({ t }) => {
  return (
    <>
      <p>{t('GAME_RULES_P12')}</p>
      <p>{t('GAME_RULES_P13')}</p>
      <div className='autobet-image-wrapper'>
        <img src={AutoBetImage2} alt='' />
        <i>{t(globalTranslationKeys.AutoCashOut)}</i>
      </div>
    </>
  );
};

export const GameTypesPopupTabContent = observer(({ t }) => {
  const { CancelationMessage1, MalfunctionMessage2, Rtp, Ranges, Odd, Min, Max, AllIn } =
    globalTranslationKeys;
  const { gameConfiguration = {} } = gameConfigStore;
  const { autobet: isAutoBetConfigEnabled = false } = gameConfiguration;

  return (
    <>
      <h4>{t('GAME_RULES_P5')}</h4>
      <p>{t('GAME_RULES_P6')}</p>
      <div className='odd-info-table-holder'>
        <div className='odd-info-table-inner'>
          <div className='odd-info-table-row' key={Date.now()}>
            <span className='odd-info-table-txt'>{t(Ranges)}</span>
            <span className='odd-info-table-txt'>{t(Odd)}</span>
          </div>
          {oddDataForHelpPopUp.map((item) => {
            const { odd, range } = item;
            return (
              <div className='odd-info-table-row' key={odd}>
                <span className='odd-info-table-txt'>{range}</span>
                <span className='odd-info-table-txt'>x{odd}</span>
              </div>
            );
          })}
        </div>
      </div>

      <p>{t('GAME_RULES_P7')}</p>
      <div className='odd-info-img'>
        <img src={InfoImg1} alt='info' />
      </div>
      <p>{t('GAME_RULES_P8')}</p>
      <div className='odd-info-img'>
        <img src={InfoImg2} alt='info' />
      </div>
      <p>{t('GAME_RULES_UPDATE')}</p>
      <div className='odd-info-img'>
        <img src={InfoImg3} alt='info' />
      </div>
      <h4>{t('GAME_RULES_P9')}</h4>
      <p>{t('GAME_RULES_P10')}</p>
      {isAutoBetConfigEnabled && <p>{t('GAME_RULES_P11')}</p>}
      <div className='odd-info-img parent'>
        <img src={InfoImg4} alt='info' />
        <span className='odd-inf-min-text'>{t(Min)}</span>
        <span className='odd-inf-max-text'>{t(Max)}</span>
        <span className='odd-inf-allin-text'>{t(AllIn)}</span>
      </div>

      <p>
        {t(CancelationMessage1)} <br /> {t(MalfunctionMessage2)}
      </p>
      <p>{t(Rtp)}</p>
    </>
  );
});

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(globalTranslationKeys.FairnessModalTitle)}</p>}
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      {new Array(10).fill('FAIRNESS_P').map((item, index) => {
        return (
          <p className='pr-f-text' key={index}>
            {t(`${item}${index + 2}`)}
          </p>
        );
      })}
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P12')}</p>
    </>
  );
};

export const HelpPopupContent = ({ t }) => {
  return (
    <>
      <p>{t('GAME_RULES_P1')}</p>
      <p>{t('GAME_RULES_P2')}</p>
      <div className='info-logo'>
        <img src={Logo} alt='Logo' />
      </div>
      <p>{t('GAME_RULES_P3')}</p>
      <p>{t('GAME_RULES_P4')}</p>
    </>
  );
};
